module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("This is dedicated to all those who have made this journey possible, including my Welsh family and my good friends in Yorkshire and in Ireland. Some of you are hidden in the pages that follow while others are warmly hidden in my thoughts. All of you are very much appreciated, especially John and Mary Crotty. I cannot thank the Crottys enough for everything they have done for me, giving me the opportunity to live this great life in Ireland. They are my Irish family and have always treated me as such.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("This work is also dedicated to the carers, those people who care for others and the world we live in, particularly at this difficult time. This includes those who care for the animals that enrich our lives in many ways and who constantly remind us that we are not the only ones worthy of this planet. For those who look after the welfare of greyhounds, this piece of work is a firm acknowledgement of their particular efforts.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0